/* eslint-disable import/prefer-default-export */

export const EXTERNAL_PAID_STRIPE = 'externally-paid';
